import { useResource } from '@landsbankinn/l16n';
import {
  Box,
  CloseIcon28,
  Container,
  IconButton,
  LanguageIcon28,
  Row,
  TopBar,
  TopBarH1,
  TopBarHomeButton,
} from '@landsbankinn/ui-kit';
import { useScreenSize } from 'src/hooks/useScreenSize';
import { useApplicationClientContext } from 'src/state';
import { getLandsbankinnUrlByLocale } from '../getLandsbankinnUrlByLocale';
import { useHeaderTitle } from '../useHeaderTitle';

export const HEIGHT = '80';

export function Header({
  onCultureSelectorToggle,
  isCultureSelectorOpen,
  title: titleProp,
}: {
  onCultureSelectorToggle?: (isOpen: boolean) => void;
  isCultureSelectorOpen?: boolean;
  title?: string;
}) {
  const [clientState] = useApplicationClientContext();
  const hookTitle = useHeaderTitle();
  const title = titleProp ?? hookTitle;
  const { locale } = useResource();
  const { isMobile } = useScreenSize();
  return (
    <TopBar
      background="gradients darkBlue"
      color="white font"
      minHeight={isMobile ? '95' : '80'}
    >
      <Container>
        <Row
          mainAxisAlignment="space between"
          crossAxisAlignment={isMobile ? 'center' : undefined}
          grow="1"
          marginTop={isMobile ? '32' : undefined}
          marginLeft={isMobile ? '-26' : undefined}
          marginRight={isMobile ? '-12' : undefined}
        >
          {!clientState.isLandsbankinnApp && (
            <Row crossAxisAlignment="center" colGap="20">
              <TopBarHomeButton
                color="red logo"
                onClick={() =>
                  (window.location.href = getLandsbankinnUrlByLocale(locale))
                }
              />
              <TopBarH1 grow="1">{title}</TopBarH1>
            </Row>
          )}
          {!!clientState.isLandsbankinnApp && (
            <>
              <TopBarHomeButton color="red logo" />
              <TopBarH1 fontWeight="medium">{title}</TopBarH1>
            </>
          )}
          {onCultureSelectorToggle ? (
            <IconButton
              aria-label={
                isCultureSelectorOpen ? 'close language' : 'open language'
              }
              instrumentAs={
                isCultureSelectorOpen
                  ? 'close_language_selector'
                  : 'open_language_selector'
              }
              data-testid="language-switcher-button"
              alignSelf="center"
              onClick={() => onCultureSelectorToggle(!isCultureSelectorOpen)}
            >
              {isCultureSelectorOpen && <CloseIcon28 color="common white" />}
              {!isCultureSelectorOpen && (
                <LanguageIcon28 color="common white" />
              )}
            </IconButton>
          ) : (
            <Box width="44" />
          )}
        </Row>
      </Container>
    </TopBar>
  );
}
